import { Component, Input, OnInit } from '@angular/core';
import { CatalogTreeCardObject } from 'src/app/models/catalog/catalog-tree-item-object.model';

@Component({
  selector: 'app-catalog-tab-general',
  templateUrl: './catalog-tab-general.component.html',
  styleUrls: ['./catalog-tab-general.component.scss']
})
export class CatalogTabGeneralComponent implements OnInit {

  @Input() node: CatalogTreeCardObject;

  constructor() {
  }

  ngOnInit() {
    this.node = CatalogTreeCardObject.create();
  }

}
